import React from 'react';
import PredictionInput from './pages/PredictionInput';
import PredictionDetail from './pages/PredictionDetail';
import Settlement from './pages/Settlement';
import History from './pages/History';
import PublicPrompt from './pages/PublicPrompt';
import SettlementQueue from './pages/SettlementQueue';
import Pairs from './pages/Pairs';
export { configure } from './api';
export const routes = [{
  path: '/extreme-movers-ohlc',
  component: <History />
}, {
  path: '/extreme-movers-ohlc/settlement',
  component: <SettlementQueue />
}, {
  path: '/extreme-movers-ohlc/pairs',
  component: <Pairs />
}, {
  path: '/extreme-movers-ohlc/create',
  component: <PredictionInput />
}, {
  path: '/extreme-movers-ohlc/prompts',
  component: <PublicPrompt />
}, {
  path: '/extreme-movers-ohlc/predictions/:id',
  component: <PredictionDetail />
}, {
  path: '/extreme-movers-ohlc/batches/:id/settlement',
  component: <Settlement />
}];
export const navigation = {
  id: 'extreme-movers-ohlc',
  label: 'Extreme Movers + OHLC',
  icon: 'ri-stock-line',
  link: '/extreme-movers-ohlc'
};
// An experiment the site runs on itself: administrators only, and not in the public menu.
export function getNavigation({ admin }) {
  if (!admin) return null;
  return { ...navigation, subItems: [
    {id:'extreme-movers-ohlc-history',label:'History',link:'/extreme-movers-ohlc',parentId:navigation.id},
    {id:'extreme-movers-ohlc-pairs',label:'V1 vs V2',link:'/extreme-movers-ohlc/pairs',parentId:navigation.id},
    ...(admin ? [
      {id:'extreme-movers-ohlc-input',label:'Prediction Input',link:'/extreme-movers-ohlc/create',parentId:navigation.id},
      {id:'extreme-movers-ohlc-settlement',label:'Settlement',link:'/extreme-movers-ohlc/settlement',parentId:navigation.id},
    ] : []),
  ] };
}
